<template>
    <van-popup
            v-model="show"
            position="bottom"
            :overlay-style="{background: 'rgba(0, 0, 0, 0.3)'}">
        <div :class="['comment-textarea',isFromAlbum&&'comment-textarea-album']">
            <textarea
                ref='myTextarea'
                :placeholder="placeholderText"
                :style="getTextAreaStyle"
                @input="handleInput"
                v-model.trim="text"
                :rows="defaultRows"
            />
            <!-- 发布 -->
            <div :class="['publish-btn',canPublish && 'active']" @click="clickSubmit">发布</div>
        </div>
    </van-popup>
</template>

<script>
import { MessageBox } from "../../vue_components/follow-btn/MessageBox/src/main.js"
import localStorageUtil from '../../_utils/localstorageUtil'
import { publishComment } from '../../js/article-main/request/api'
import Popup from 'vant/lib/popup'
import Field from 'vant/lib/field'
import 'vant/lib/popup/style';
import 'vant/lib/field/style';
import Util from "@/_utils/util.js"

export default {
	name: "",
    components: {
         vanPopup: Popup,
         vanField: Field
    },
	props: {
        from: {
            default: 'normal',
			type: String
        },
        placeholderText: {
			default: '我来说两句...',
			type: String
		},
	},
	computed: {
        // 来自图集页
        isFromAlbum() {
            return this.from == 'album'
        },
		getTextAreaStyle() {
			return  {
				height: this.minHeight + 12 + 'px', // 12-padding
				'line-height': this.minHeight + 'px',
			}
		},
		maxHeight() {
			return this.minHeight * this.maxRow
		},
        canPublish() {
            return !!this.text
        },
        defaultRows() { // fix:android端qq浏览器，点击发布无效
            // android端qq浏览器默认行数为3行，其余为1行
            const ua = window.navigator.userAgent
            const isAndroid = /Android/i.test(ua)
            const isQQ = ua.toLowerCase().indexOf('qqbrowser') >= 0
            return isAndroid && isQQ ? 3 : 1
        },
        // popPos() {
        //     const ua = window.navigator.userAgent
        //     const isTouTiao = /ttwebview/i.test(ua)
        //     return isTouTiao ? 'center' : 'bottom'
        // }
	},
	data() {
		return {
            minHeight: 20,
            maxLength: 1000,
            isLogin: false,
            maxRow: 4,
			text: '',
            scrollTop: 0,
            originalBodyStyle: '',
            show: true,
            spmCCode: 'comment-reply'
		}
	},
    mounted() {
        this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        console.log(this.scrollTop, 'scroll');
        this.$refs.myTextarea.focus();
        this.getUserInfo()
    },
    destroyed() {
    },
    watch: {
        show(_new,_old) {
            if(!_new) {
                window.sohuSpm.sendAction({
                    acode: '3560',
                    clkParam: `sourceId:mp_${window.cfgs.newsId};`
                });
                this.closeMask()
            }
        }
    },
	methods: {
        handleBlur() {
            window.scrollTo(0, this.scrollTop)
        },
        getUserInfo() {
            const userInfo = window.userInfo
            if(userInfo?.avatar || userInfo?.userId) {
                this.isLogin = true
            }
        },
        clickSubmit() {
            if(!this.canPublish)return
            // 未登录
            if(!this.isLogin) {
                // 缓存未发布的评论
                localStorageUtil.setItem(`${window.cfgs?.newsId}_comment`, this.text)
                let env = Util.getEnvironment()

                const loginHost = {
                    test: "https://test-m.sohu.com/login?type=1&origin=2",
                    pre: "https://pre-m.sohu.com/login?type=1&origin=2",
                    prod: "https://m.sohu.com/login?type=1&origin=2",
                }
                const loginHref = loginHost[env]
                const spmCode = window.sohuSpm.getCodes()
                const spm = `${spmCode && spmCode.a}.${spmCode && spmCode.b}.${this.spmCCode}.2.${spmCode && spmCode.e}`
                window.location.href = `${loginHref}&r=${encodeURIComponent(window.location.href)}&spm=${spm}`
                return
            }
            window.sohuSpm.sendAction({
                acode: '3559',
                clkParam: `sourceId:mp_${window.cfgs.newsId};source:fb`
            });
            // 已登录-去发布
            publishComment(this.text).then((res)=>{
                if(res.code == 200) {
                this.$emit('addCommentCount')
                window?.eventBus?.$emit('addFakeComment',res?.data)
                window.h5_sohu.plugin.api.call('toast',
                    {text:'发布成功',type:1},
                    function(){})
                }else if(res.code == 417) { // 封禁
                    window?.EVENT_BUS?.$emit('showBannedNotice')
                }
                else {
                    window.h5_sohu.plugin.api.call('toast',
                        {text:res.msg,type:2},
                        function(){})
                }
            }).catch((e)=>{
                window.h5_sohu.plugin.api.call('toast',
                    {text:'发布失败',type:2},
                    function(){})
            }).finally(()=>{
                this.closeMask()
            })
        },
        closeMask() {
            this.$emit('closeMask',false)
            window.scrollTo(0, this.scrollTop)
        },
		handleInput(e) {
			const textarea = e.target
			const value = textarea.value
			// 动态改变textarea的高度，不超过最大高度
			textarea.style.height = 'auto'
            textarea.style.height = (textarea.scrollHeight > this.maxHeight ? this.maxHeight : textarea.scrollHeight) + 'px'
			// 超出最大长度截断
			if(value && value.length > this.maxLength) {
				this.text = value.substring(0,this.maxLength)
                // toast提示
                MessageBox.$toast({ title: `正文字数超限，最多${this.maxLength}字`,top:'65%' },1000)
			}
		}
	}
}
</script>

<style lang="less" scoped>
.comment-textarea {
    width: 100%;
    display: flex;
    background: white;
    padding: 20px 32px; /*px*/
    box-sizing: border-box;
    textarea {
        flex: 1;
        border: none;
        outline: none;
        resize: none;
        appearance:none;
        padding: 0;
        margin: 0;
        font-size: 28px;/*px*/
        box-sizing: border-box;
        padding: 12px 24px;/*px*/
        border-radius: 8px;/*px*/
        border: 2px solid rgb(245, 246, 247);/*px*/
        color: rgb(36, 37, 41);
        background: rgb(245, 246, 247);
        scrollbar-width: none; /* Firefox 64+ */
        -ms-overflow-style: none; /* IE/Edge */
    }
    textarea::placeholder {
        color: #999999;
        font-size: 28px; /*px*/
    }
    textarea::-webkit-scrollbar {
        display: none;
    }

    .publish-btn {
        height: 64px; /*px*/
        width: 120px; /*px*/
        margin-left: 24px;/*px*/
        background: #dcdcdc;
        border-radius: 8px;/*px*/
        font-size: 28px;/*px*/
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        box-sizing: border-box;
        font-weight: 700;
    }
    .active {
        background: #ffd100;
        color: #000;

    }
}
// 图集页 黑色
.comment-textarea-album {
    box-shadow: inset 0px 1px 0px 0px rgba(255,255,255,0.2);/*px*/
    color: #999;
    background: #010101;
    textarea {
        color: #999999;
        background: rgba(255,255,255,0.2);
        border: none !important;
    }
    textarea::placeholder {
        color: #999999;
    }
    .publish-btn {
        background: rgba(255,255,255,0.2);
        color: #999;
    }
    .active {
        background: #ffd100;
        color: #111;

    }
}
</style>
